import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FEATURE_NAME } from './project-cost-limit-dialog.constant';
import { ProjectCostLimitDialogState } from './project-cost-limit-dialog.model';

export const slice = createFeatureSelector<ProjectCostLimitDialogState>(FEATURE_NAME);

export const selectMode = createSelector(slice, (s) => s.mode);
